import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UpdateKsfTemplate } from 'projects/shared/src/lib/models/ksf.model';

@Component({
    selector: 'lib-ksf-info',
    templateUrl: './ksf-info.component.html',
    styleUrls: ['./ksf-info.component.scss'],
    standalone: false
})
export class KsfInfoComponent {
  // Event emitted to the parent component
  @Output() nextStepEvent = new EventEmitter();
  @Output() setShowWarringEvent = new EventEmitter<boolean>();
  @Output() setShowClausesEvent = new EventEmitter<boolean>();
  @Output() setSelectedFieldsValuesEvent = new EventEmitter<any[]>();
  @Output() setShowFieldIndexArrayEvent = new EventEmitter<boolean[]>();
  @Output() recalculateKsfPricesEvent = new EventEmitter();
  @Output() setKsfTemplateEvent = new EventEmitter<UpdateKsfTemplate>();

  // Input properties to receive data from the parent component
  @Input() ksfPriceResult: any;
  @Input() selectedFieldsValues: any[] = []; // Is usesd to show the slected values in the dropdowns
  @Input() showFieldIndexArray: boolean[] = [];
  @Input() ksfPriceLoading: boolean = false;
  @Input() ksfTemplate: UpdateKsfTemplate = {} as UpdateKsfTemplate;

  // Internal state variables
  showClauses: boolean = false;
  showWarring: boolean = false;

  /**
   * Check if all fields in the `showFieldIndexArray` are set (true).
   * Returns true if all fields are set, otherwise false.
   * @returns boolean - True if all fields are set, otherwise false.
   */
  allFieldsSet(): boolean {
    return this.showFieldIndexArray.every((value) => value);
  }

  /**
   * Validate additional information based on the current price result state.
   * Proceeds to the next step if no warnings or clauses are present.
   * @returns void
   */
  validateExtraInfo() {
    // Check if the price result state indicates warnings
    if (this.ksfPriceResult.state == 'Warnings') {
      this.showWarring = true;
      this.setShowWarringEvent.emit(this.showWarring);
      return;
    }

    // Check if there are clauses to display and no warnings
    if (this.ksfPriceResult.clauses.length > 0 && !this.showWarring) {
      this.showClauses = true;
      this.setShowClausesEvent.emit(this.showClauses);
      return;
    }

    // Proceed to the next step if no warnings or clauses are present
    this.nextStepEvent.emit();
  }

  /**
   * Handle the selection of an item from a dropdown menu.
   * and emits events to update the template and recalculate prices.
   * @param item - The selected item from the dropdown.
   * @param dropdownId - The id of dropdown selected.
   * @param index - The index of the selected field.
   * @returns void
   */
  dropdownOutput(item: any, dropdownId: string, index: number) {
    if (dropdownId == 'fields') {
      // Update selected field values and mark the field index as set
      this.selectedFieldsValues[index] = item;
      this.showFieldIndexArray[index] = true;

      this.setSelectedFieldsValuesEvent.emit(this.selectedFieldsValues);
      this.setShowFieldIndexArrayEvent.emit(this.showFieldIndexArray);

      // Show the next field if it is of type 'Complex'
      if (this.ksfPriceResult.fields[index + 1]) {
        if (this.ksfPriceResult.fields[index + 1].type.kind === 'Complex') {
          this.showFieldIndexArray[index + 1] = true;
        }
      }

      // Update the template with the selected value
      this.ksfTemplate.fields[index].Value = item.value;
      this.setKsfTemplateEvent.emit(this.ksfTemplate);

      // Recalculate prices based on the updated template
      this.recalculateKsfPricesEvent.emit();
    }
  }
}
